import { render } from "./BaseViewContainer.vue?vue&type=template&id=3af6c192&scoped=true"
import script from "./BaseViewContainer.vue?vue&type=script&lang=js"
export * from "./BaseViewContainer.vue?vue&type=script&lang=js"

import "./BaseViewContainer.vue?vue&type=style&index=0&id=3af6c192&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3af6c192"]])

export default __exports__